<template>
  <div>
    <div v-if="imgUrlList.length" class="mgn-b10 bgf-black" :class="{'hiddle-preview': isHasOpenBtn,'open-height': (isOpenImg&&isHasOpenBtn),'height180':(!isOpenImg&&isHasOpenBtn )}">
      <template v-for="(it,index) in imgUrlList">
        <img :key="it.imageUrl+index" :src="it.imageUrl" alt="" @click="onPreview(index)" style="display:block;width:100%;height:auto;">
      </template>
      <div v-if="isHasOpenBtn" class="open-message-img" @click.stop="()=>{isOpenImg = !isOpenImg}">
        <span>{{!isOpenImg?'展开':'收起'}}详情</span>
        <qxs-icon name="arrow_right" class="mgn-l5" :class="!isOpenImg ? 'transform-b90': 'transform-t90'"></qxs-icon>
      </div>
    </div>
    <div v-if="playUrl.length && isShow" class="mgn-b10 video-body-box">
      <aliPlayer
        :ref="videoPlayer"
        :id="videoPlayer"
        :aliPlayOptions="aliPlayOptions"
      ></aliPlayer>
    </div>
		<image-preview-modal v-show="showPreview" :activeIndex="previewIndex" :image-list="imageList" @hidePreview="hidePreview" />
  </div>
</template>

<script>
import aliPlayer from '@/components/aliPlayer'
	import ImagePreviewModal from '@/baseComponents/ImagePreviewModal'
export default {
  name: 'ExamImageVideo',
  components: {
    aliPlayer,
		ImagePreviewModal
  },
  props:{
    isHasOpenBtn: {
      type: Boolean,
      default: true,
    },
    item:{      // 每一题的对象
      type:Object,
      default:() => {
        return {}
      }
    },
    imgUrlList: {
      type: Array,
      default: () => {
        return []
      }
    },
    playUrl: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      isOpenImg: false,
      aliPlayOptions:{},
			showPreview: false,
			previewIndex: 1,
			imageList: []
    }
  },
  computed: {
    videoPlayer() {
      return 'videoPlayer' + this.item.examId
    },
    player() {
			return this.$refs[this.videoPlayer]&&this.isShow && this.$refs[this.videoPlayer].player
    },
    isShow() {
      return !!this.aliPlayOptions.source
    },
  },
  mounted() {
    this.$set(this.aliPlayOptions, 'source', this.item.playUrl)
  },
  methods: {
    onPreview(index) {
			this.imageList = this.item.imgUrlList.map(v=>v.imageUrl)
			this.previewIndex = index
			this.showPreview = true
    },
		hidePreview() {
			this.showPreview = false
      this.previewIndex = 1
			this.imageList = []
		},
  },

}
</script>

<style lang="scss" scoped>
.margin-l8 { margin-left: 8px;}
.mgn-b10 { margin-bottom: 10px;}
.pdg-b70 { padding-bottom: 70px;}
.bgf-black { background: #f1f1f1;}

.video-body-box {
  width: 100%;
  min-height:180px;
  background: #f1f1f1;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
}
.hiddle-preview {
  overflow: hidden;
  position: relative;
	z-index: 100;
}
.open-message-img {
	width: 100%;
	height: 70px;
	background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.59) 30%, rgba(255, 255, 255, 0.92) 65%, #FFFFFF 100%);
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	bottom: 0;
	left: 0;
	z-index: inherit;
	span {
		color: #1E1E1E;
	}
}
.transform-b90 {
	transform:rotate(90deg);
	-ms-transform:rotate(90deg); 	/* IE 9 */
	-moz-transform:rotate(90deg); 	/* Firefox */
	-webkit-transform:rotate(90deg); /* Safari 和 Chrome */
	-o-transform:rotate(90deg); 	/* Opera */
}
.transform-t90 {
	transform:rotate(-90deg);
	-ms-transform:rotate(-90deg); 	/* IE 9 */
	-moz-transform:rotate(-90deg); 	/* Firefox */
	-webkit-transform:rotate(-90deg); /* Safari 和 Chrome */
	-o-transform:rotate(-90deg); 	/* Opera */
}

.open-height {
  height: auto;
  padding-bottom: 70px;
  transition: height 1s linear 500ms;
  -moz-transition: height 1s linear 500ms; /* Firefox 4 */
  -webkit-transition: height 1s linear 500ms; /* Safari and Chrome */
  -o-transition: height 1s linear 500ms; /* Opera */
}
.height180 {
  height: 180px;
  transition: height 1s linear 500ms;
  -moz-transition: height 1s linear 500ms; /* Firefox 4 */
  -webkit-transition: height 1s linear 500ms; /* Safari and Chrome */
  -o-transition: height 1s linear 500ms; /* Opera */
}
</style>
